import {call, put} from 'redux-saga/effects';

import axios from 'axios';
import * as lexActionType from '../actionsType/lexDetail.actionType';
import {getBaseUrl} from '../../../core/utility/filter.utility';

import * as staticConstants from '../../../core/constants/staticConstants';
import * as types from '../../../core/constants/ActionTypes';

function getLexDetail(reqObj) {
    // in case of Learning Module, when app is loaded & we have lp ID, no need to send lp code.
    if ((reqObj.lexType !== 4) && !!reqObj.lpId) {
        delete reqObj.lpCode;
    }

    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/lp/getLexContentDetails`,
        data: reqObj
    });
    // return axios.get('static/data/4-lp-detail.json');
    // return axios.get('static/data/certDetail.json');
}

export function* fetchLexDetailSaga(request) {
    try {
        const response = yield call(getLexDetail, request.payload);
        const content = response.data;
        // const content = response.data[0];
        if (typeof content === 'string') {
            yield put({
                type: lexActionType.FETCHING_LEX_ERROR,
                payload: content
            });
            yield put({
                type: types.SET_LEX_EXCEPTION,
                payload: {
                    type: staticConstants.LEX_EXCP_ERROR,
                    desc: content
                }
            });
        } else {
            yield put({
                type: lexActionType.FETCHING_LEX_SUCCESS,
                payload: content
            });
            yield put({
                type: lexActionType.SET_LEX_LASTLAUNCHED,
                payload: content.lastla
            });
            yield put({
                type: lexActionType.SET_IS_ENROLLED,
                payload: content.isEnrolled
            });
        }
    } catch (error) {
        yield put({
            type: lexActionType.FETCHING_LEX_ERROR,
            payload: 'There has been some issue with 3DS Learning Space. Please try after sometime.'
        });
        yield put({
            type: types.SET_LEX_EXCEPTION,
            payload: {
                type: staticConstants.LEX_EXCP_ERROR,
                desc: 'Kindly refresh the page'
            }
        });
    }
}
